export default "Le Fonds Chaleur ADEME subventionne jusqu'à 60% vos installations de chaleur renouvelable (biomasse, géothermie, solaire thermique). Éligibilité et démarche pour les entreprises.";
